import s from './add-card-success.module.scss'
import { motion } from 'framer-motion';
import { useState } from 'react';
import classNames from 'classnames';
import { Button } from '@shared/ui/button/button';
import { IconChevronRight, IconCircleCheckFilled } from '@tabler/icons-react';
import { getCDNPath } from '@utils/lib/getCDNpath';

export const AddCardSuccess = () => {
	const [isMascotLoaded, setIsMascotLoaded] = useState(false)

	return (
		<motion.div
			className={s.wrapper}
			initial={{ opacity: 0, y: 16 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
		>
			<div className={s.card}>
				<div className={s.header}>
					<div className={s.headerContent}>
						<motion.span
							className={s.badge}
							initial={{ scale: 0 }}
							animate={{ scale: 1 }}
							transition={{ type: 'spring', stiffness: 260, damping: 18, delay: 0.1 }}
						>
							<IconCircleCheckFilled size={36} className={s.badgeIcon}/>
						</motion.span>
						<h2 className={s.title}>Карта успешно привязана!</h2>
						<p className={s.subtitle}>Теперь ваша анкета будет видна другим пользователям в поиске.</p>
					</div>
					<img
						className={classNames(s.mascot, isMascotLoaded && s.mascotLoaded)}
						src={getCDNPath('images/mascot/man-thumbs-up.webp')}
						alt=""
						onLoad={() => setIsMascotLoaded(true)}
						onError={(e) => { e.target.style.display = 'none'; }}
					/>
				</div>

				<div className={s.buttons}>
					<Button theme='secondary' label='На главную' to={'/'} className={s.btn}/>
					<Button label='К настройкам' to={'/settings'} rightIcon={<IconChevronRight size={16}/>} className={s.btn}/>
				</div>
			</div>
		</motion.div>
	)
}
